import { useMemo } from "react";

export const useDynamicDetailRows = (schema, row) =>
  useMemo(() => {
    const columns = schema?.columns;
    if (!Array.isArray(columns) || columns.length === 0) return [];
    return [...columns]
      .sort((a, b) => (a.position ?? 0) - (b.position ?? 0))
      .map(column => ({
        name: column.field_id,
        label: column.display_name,
        type: column.type,
        required: !!column.is_required,
        unique: !!column.is_unique,
        value: row?.[column.field_id] ?? null,
        display: row?.[`${column.field_id}__display`] ?? null,
        column,
      }));
  }, [schema, row]);

export default useDynamicDetailRows;
